<template>
    <ModalComponent 
        :name="'invitaciones-copiadas'"
        :title="'Invitaciones generadas'"
        v-on:close="() => close()"
    >
        <template v-slot:default>
            <p>Todas las entradas de los pedidos han sido generadas correctamente.</p>
            <h4>Correos de invitaciones</h4>

            <ValidationObserver tag="div" class="scroll-content p-3" ref="observer">
                <template v-for="(order, index) in orders">
                    <div class="mt-3" v-bind:key="order.id">
                        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                            <label>{{ order.id }} - {{ order.entradas && order.entradas.length > 0 ? order.entradas[0].concept : '' }}</label>
                            <input :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :id="'orderInvitation-' + order.id" placeholder="Email" v-model="orders[index].email_comprador"/>
                            <span class="error invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </template>
            </ValidationObserver>
            <div v-if="loading">
                <LoaderComponent/>
            </div>
            <div>
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="caducidad_entradas" id="caducidad_entradas"/>
                    <label class="custom-control-label" for="caducidad_entradas">Caducidad</label>
                </div>
            </div>
            <div v-if="caducidad_entradas">
                <label for="fecha_fin">Fecha de caducidad</label>
                <ValidationProvider name="fecha_fin" rules="required" v-slot="{ errors }" mode="passive">
                    <datetime 
                        v-model="fecha_caducidad"
                        :input-class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                        type="datetime"
                        input-id="fecha_fin"
                        value-zone="Europe/Madrid"
                        :min-datetime="new Date().toISOString()"
                    />
                    <span v-if="errors[0]" id="exampleInputEmail1-error" class="error invalid-feedback"
                          style="display: block"
                    >{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </template>
        <template v-slot:footer>
            <Button class="active mr-2" :disabled="loading" @click.prevent="enviarInvitaciones()">Enviar invitaciones</Button>
            <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
        </template>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";
    import LoaderComponent from '@/components/preloader/LoaderComponent';

    export default {
        props: ['sesion', 'error', "orders", "eventoId", "sesionId"],
        data() {
            return {
                loading: false,
                caducidad_entradas: false,
                fecha_caducidad: null
            }
        },
        methods: {
            close() {
                this.$emit('close', 'invitaciones-copiadas');
            },
            async enviarInvitaciones() {
                const isValid = await this.$refs.observer.validate();
                if(!isValid) return;

                this.loading = true;

                const sendEmailPromises = [];

                for(const order of this.orders) {

                    const data = {
                        evento_id: this.eventoId,
                        sesion_id: this.sesionId,
                        user_order: order.id,
                        qr_codes: order.qr_codes,
                        email: order.email_comprador,
                        caducidad_entradas: this.caducidad_entradas,
                        fecha_caducidad: this.fecha_caducidad
                    };

                    sendEmailPromises.push(this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.entradas.enviar.email'), data));
                }

                Promise.all(sendEmailPromises).then(values => {
                    const message = values[0].data.message;
                    this.$toast.success(message);
                    this.close();
                }).finally(() => this.loading = false);

            }
        },
        components: { ModalComponent, LoaderComponent }
    }
</script>
